import styled from 'styled-components';
import { LinkButton } from '../../../../styles/components';

const AddFieldsButton = styled(LinkButton)`
  margin-top: ${(props): string => props.theme.spaces.md};
`;

export { AddFieldsButton };
